import { combineReducers } from 'redux'

import { authentication } from './authentication.reducer'
import { registration } from './registration.reducer'
import { users } from './users.reducer'
import { alert } from './alert.reducer'
import { etime } from './etime.reducer'
import { roster } from './roster.reducer'
import { TokenReducer } from './token.reducer'
import { BranchReducer } from './branch.reducer'
import { DepartmentReducer } from './department.reducer'
import { ActionTypesReducer } from './actionTypes.reducer'
import { biznumbers } from './biznumbers.reducer'
import { templates } from './templates.reducer'
import { contacts } from './contact.reducer'
import { sms } from './sms.reducer'
import { payrollDefaultWorkHour } from './payrollDefaultWorkHour.reducer'
import { payrollNormalWorkHour } from './payrollNormalWorkHour.reducer'
import { colors } from './customization/colors.reducer'
import { employeeLeave } from './employeeLeave.reducer'

const rootReducer = combineReducers({
    authentication,
    registration,
    users,
    alert,
    etime,
    roster,
    TokenReducer,
    BranchReducer,
    DepartmentReducer,
    ActionTypesReducer,
    biznumbers,
    templates,
    contacts,
    sms,
    payrollDefaultWorkHour,
    payrollNormalWorkHour,
    colors,
    employeeLeave
})

export default rootReducer
